import { z } from "zod";

const AvatarKeys = z.enum(["thumb", "preview", "large", "retina", "original"]);

export const AvatarSchema = z.record(AvatarKeys, z.string().nullable());
